
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flights/[[...param]]",
      function () {
        return require("private-next-pages/flights/[[...param]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flights/[[...param]]"])
      });
    }
  